import { render, staticRenderFns } from "./edit-form-section.vue?vue&type=template&id=36b2978c&scoped=true&"
import script from "./edit-form-section.vue?vue&type=script&lang=ts&"
export * from "./edit-form-section.vue?vue&type=script&lang=ts&"
import style0 from "./edit-form-section.vue?vue&type=style&index=0&id=36b2978c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2978c",
  null
  
)

export default component.exports